<template>
  <div v-if="message" class="textLimit" :class="level">{{ message }}</div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  limit: {
    type: Number,
    required: true,
  },
  value: {
    type: [String, InputEvent],
    required: true,
  },
  warnLimit: {
    type: Number,
    required: true,
  },
});

const level = computed(() => {
  if (props.value?.length === props.limit) {
    return 'limit';
  } else if (props.value?.length > props.limit) {
    return 'over';
  } else if (props.value?.length > props.warnLimit) {
    return 'warn';
  } else {
    return 'ok';
  }
});

const message = computed(() => {
  if (level.value === 'over') {
    return `Please enter less than ${props.limit} characters.`;
  } else if (level.value === 'warn' || level.value === 'limit') {
    return `${props.value.length} / ${props.limit}`;
  } else {
    return false;
  }
});
</script>
<style lang="scss" scoped>
.textLimit {
  text-align: right;
  @include type-size('x-small');
  &.limit {
    color: var(--c__warn);
  }
  &.over {
    text-align: left;
    letter-spacing: -0.03em;
    color: var(--c__warn);
  }
}
</style>
